/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { isEmpty } from 'lodash'

import { EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { Region as AdminRegion } from '@modules/cluster-admin-api/v1/types'
import type { Region as UserRegion } from '@modules/cluster-user-api/v1/types'
import genericMessages from '@modules/project-lib/genericMessages'

import type { FC } from 'react'

type Props = {
  regionId: string
  allRegions: AdminRegion[] | UserRegion[] | undefined
}

const FormattedRegionAndProvider: FC<Props> = ({ regionId, allRegions }) => {
  const region = allRegions?.find((item) => item.id === regionId)

  if (!region) {
    if (!isEmpty(regionId)) {
      return <EuiText size='s'>{regionId}</EuiText>
    }

    return (
      <EuiText size='s'>
        <FormattedMessage {...genericMessages.unknown} />
      </EuiText>
    )
  }

  return <EuiText size='s'>{`${region.csp.toUpperCase()} - ${region.name}`}</EuiText>
}

export default FormattedRegionAndProvider
